import { createBrowserRouter } from 'react-router-dom';
import BlankLayout from '../components/Layouts/BlankLayout';
import DefaultLayout from '../components/Layouts/DefaultLayout';
import { routes } from './routes';
import Error404 from '../pages/Pages/Error404';
import { IsAccessableComponent } from '../components/IsAuthenticated';

const defaultRoutes = routes
  .filter((route) => route.layout !== 'blank')
  .map((route) => ({
    ...route,
    element: (
      <IsAccessableComponent path={route.path} type={''}>
        {route.element}
      </IsAccessableComponent>
    ),
  }));

const blankRoutes = routes
  .filter((route) => route.layout === 'blank')
  .map((route) => ({
    ...route,
    element: (
      <IsAccessableComponent path={route.path} type={''}>
        {route.element}
      </IsAccessableComponent>
    ),
  }));

const finalRoutes = [
  {
    element: <DefaultLayout />,
    errorElement: <Error404 />,
    children: defaultRoutes,
  },
  {
    element: <BlankLayout />,
    errorElement: <Error404 />,
    children: blankRoutes,
  },
];

const router = createBrowserRouter(finalRoutes);

// console.log(router);

export default router;
